import React from "react";
import { useNavigate } from "react-router-dom";

const BookingAlertModal = ({ isOpen, toggle, booking, onDismiss }) => {
  const navigate = useNavigate();

  if (!isOpen || !booking) return null;

  const bookingId = booking.bookingId || booking.BookingId || booking.id || booking.Id || "New";
  const customerName = booking.customerName || booking.CustomerName || booking.UserName || "Customer";
  const customerMobile = booking.customerMobile || booking.CustomerMobile || booking.UserMobileNo || "";
  const pickup = booking.pickup || booking.pickupAddress || booking.PickupAddress || "Pickup location not specified";
  const drop = booking.drop || booking.dropAddress || booking.Stop1Address || booking.Stop1ReceiverHouseDetails || "Drop location not specified";
  const fare = booking.fare ?? booking.price ?? booking.Price ?? 0;
  const km = booking.km ?? booking.totalTripKM ?? booking.TotalTripKM ?? 0;

  const vehicleName = 
    booking.vehicleTypeName ||
    booking.VehicleTypeName || 
    booking.demandedVehicleType ||
    booking.DemandedVehicleType || 
    booking.vehicleType || 
    booking.VehicleType || 
    booking.vehicleCategory || 
    booking.VehicleCategory || 
    "";

  const vehicleCategory = 
    booking.vehicleCategoryName ||
    booking.VehicleCategoryName || 
    booking.vehicleCategory || 
    booking.VehicleCategory || 
    "";

  const capacity = 
    booking.capacity ||
    booking.weightCapacity ||
    booking.WeightCapacity || 
    booking.demandedWeightCapacity ||
    booking.DemandedWeightCapacity || 
    booking.WeightRangeTo || 
    "";

  const goodsType = 
    booking.goodsType ||
    booking.GoodsType || 
    "";

  const time = booking.time || booking.BookingDate || booking.dateStr || "";
  const isAccepted = booking.isAccepted || booking.statusText === "Accepted by Driver" || Number(booking.StatusId || booking.F_StatusMaster || 0) > 1;

  const handleAssignClick = (e) => {
    if (e) e.stopPropagation();
    if (toggle) toggle();
    if (onDismiss) onDismiss();
    navigate("/AssignDriver", { state: { highlightBookingId: String(bookingId) } });
  };

  const handleClose = (e) => {
    if (e) e.stopPropagation();
    if (onDismiss) onDismiss();
    else if (toggle) toggle();
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 999999,
        backgroundColor: "rgba(15, 23, 42, 0.7)",
        backdropFilter: "blur(4px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "16px",
      }}
      onClick={handleClose}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "480px",
          backgroundColor: "#ffffff",
          borderRadius: "14px",
          boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.35)",
          overflow: "hidden",
          animation: "modalSlideDown 0.25s ease-out",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Modal Header */}
        <div
          style={{
            background: "linear-gradient(135deg, #EF4444 0%, #F97316 100%)",
            color: "#ffffff",
            padding: "16px 20px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <div
              style={{
                width: "40px",
                height: "40px",
                borderRadius: "50%",
                backgroundColor: "rgba(255, 255, 255, 0.22)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "22px",
              }}
            >
              🚕
            </div>
            <div>
              <div style={{ fontSize: "17px", fontWeight: "700", lineHeight: 1.2 }}>
                New Ride Booking Alert!
              </div>
              <div style={{ fontSize: "12px", opacity: 0.9, marginTop: "2px" }}>
                Ride #{bookingId} {vehicleName ? `• ${vehicleName}` : ""} {time ? `• ${time}` : ""}
              </div>
            </div>
          </div>

          <button
            type="button"
            onClick={handleClose}
            style={{
              background: "rgba(255, 255, 255, 0.2)",
              border: "none",
              borderRadius: "50%",
              width: "30px",
              height: "30px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#ffffff",
              fontSize: "16px",
              cursor: "pointer",
              fontWeight: "bold",
            }}
            title="Dismiss"
          >
            ✕
          </button>
        </div>

        {/* Modal Body */}
        <div style={{ padding: "18px 20px", backgroundColor: "#F8FAFC" }}>
          {/* Customer & Status Header */}
          <div
            style={{
              backgroundColor: "#ffffff",
              borderRadius: "10px",
              padding: "12px 14px",
              border: "1px solid #E2E8F0",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "12px",
            }}
          >
            <div>
              <div style={{ fontSize: "11px", color: "#64748B", fontWeight: "700", textTransform: "uppercase" }}>
                Customer
              </div>
              <div style={{ fontSize: "14px", fontWeight: "700", color: "#0F172A", marginTop: "2px" }}>
                👤 {customerName}
              </div>
              {customerMobile && (
                <div style={{ fontSize: "13px", color: "#2563EB", fontWeight: "500", marginTop: "1px" }}>
                  📞 {customerMobile}
                </div>
              )}
            </div>

            <div style={{ textAlign: "right" }}>
              <span
                style={{
                  display: "inline-block",
                  padding: "4px 10px",
                  borderRadius: "20px",
                  fontSize: "11px",
                  fontWeight: "700",
                  backgroundColor: isAccepted ? "#DCFCE7" : "#FEE2E2",
                  color: isAccepted ? "#15803D" : "#B91C1C",
                  border: isAccepted ? "1px solid #BBF7D0" : "1px solid #FECACA",
                }}
              >
                {isAccepted ? "✅ DRIVER ASSIGNED" : "🚨 NEW BOOKING"}
              </span>
              {vehicleName && (
                <div style={{ fontSize: "11px", color: "#1E40AF", marginTop: "4px", fontWeight: "700" }}>
                  🛺 {vehicleName}
                </div>
              )}
            </div>
          </div>

          {/* Demanded Vehicle Section (गाड़ी विवरण) */}
          <div
            style={{
              backgroundColor: "#EFF6FF",
              borderRadius: "10px",
              padding: "12px 14px",
              border: "1px solid #BFDBFE",
              marginBottom: "12px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <div
                style={{
                  width: "42px",
                  height: "42px",
                  borderRadius: "10px",
                  backgroundColor: "#DBEAFE",
                  border: "1px solid #93C5FD",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "22px",
                  flexShrink: 0,
                }}
              >
                🛺
              </div>
              <div>
                <div style={{ fontSize: "11px", color: "#1E40AF", fontWeight: "700", textTransform: "uppercase", letterSpacing: "0.5px" }}>
                  Vehicle Demanded (गाड़ी की मांग)
                </div>
                <div style={{ fontSize: "15px", fontWeight: "800", color: "#1E3A8A", marginTop: "2px", display: "flex", alignItems: "center", gap: "8px", flexWrap: "wrap" }}>
                  <span>{vehicleName || "Loading Taxi / Vehicle"}</span>
                  {capacity && (
                    <span
                      style={{
                        fontSize: "11px",
                        fontWeight: "700",
                        color: "#1E40AF",
                        backgroundColor: "#BFDBFE",
                        padding: "2px 8px",
                        borderRadius: "12px",
                      }}
                    >
                      {capacity} kg
                    </span>
                  )}
                </div>
                {vehicleCategory && vehicleCategory !== vehicleName && (
                  <div style={{ fontSize: "12px", color: "#3B82F6", fontWeight: "600", marginTop: "1px" }}>
                    {vehicleCategory}
                  </div>
                )}
              </div>
            </div>

            {goodsType && (
              <div style={{ textAlign: "right", flexShrink: 0, marginLeft: "8px" }}>
                <div style={{ fontSize: "10px", color: "#1E40AF", fontWeight: "700", textTransform: "uppercase" }}>
                  Goods Type
                </div>
                <span
                  style={{
                    display: "inline-block",
                    marginTop: "2px",
                    padding: "3px 8px",
                    borderRadius: "6px",
                    fontSize: "11px",
                    fontWeight: "700",
                    backgroundColor: "#ffffff",
                    color: "#1E3A8A",
                    border: "1px solid #93C5FD",
                  }}
                >
                  📦 {goodsType}
                </span>
              </div>
            )}
          </div>

          {/* Route Details Box */}
          <div
            style={{
              backgroundColor: "#ffffff",
              borderRadius: "10px",
              padding: "14px",
              border: "1px solid #E2E8F0",
              marginBottom: "12px",
            }}
          >
            {/* Pickup */}
            <div style={{ display: "flex", alignItems: "flex-start", gap: "10px" }}>
              <span style={{ fontSize: "15px", marginTop: "1px" }}>🟢</span>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: "11px", color: "#64748B", fontWeight: "700", textTransform: "uppercase" }}>
                  Pickup Location
                </div>
                <div style={{ fontSize: "13px", color: "#1E293B", fontWeight: "500", marginTop: "2px", wordBreak: "break-word" }}>
                  {pickup}
                </div>
              </div>
            </div>

            {/* Dotted Route Connector */}
            <div
              style={{
                borderLeft: "2px dashed #CBD5E1",
                height: "16px",
                marginLeft: "7px",
                marginVertical: "2px",
              }}
            />

            {/* Drop */}
            <div style={{ display: "flex", alignItems: "flex-start", gap: "10px" }}>
              <span style={{ fontSize: "15px", marginTop: "1px" }}>🏁</span>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: "11px", color: "#64748B", fontWeight: "700", textTransform: "uppercase" }}>
                  Drop Location
                </div>
                <div style={{ fontSize: "13px", color: "#1E293B", fontWeight: "500", marginTop: "2px", wordBreak: "break-word" }}>
                  {drop}
                </div>
              </div>
            </div>
          </div>

          {/* Fare & Distance Row */}
          <div style={{ display: "flex", gap: "10px" }}>
            <div
              style={{
                flex: 1,
                backgroundColor: "#ffffff",
                padding: "10px",
                borderRadius: "10px",
                border: "1px solid #E2E8F0",
                textAlign: "center",
              }}
            >
              <div style={{ fontSize: "11px", color: "#64748B", fontWeight: "600" }}>Estimated Fare</div>
              <div style={{ fontSize: "18px", fontWeight: "800", color: "#16A34A", marginTop: "2px" }}>
                ₹{fare}
              </div>
            </div>

            <div
              style={{
                flex: 1,
                backgroundColor: "#ffffff",
                padding: "10px",
                borderRadius: "10px",
                border: "1px solid #E2E8F0",
                textAlign: "center",
              }}
            >
              <div style={{ fontSize: "11px", color: "#64748B", fontWeight: "600" }}>Trip Distance</div>
              <div style={{ fontSize: "18px", fontWeight: "800", color: "#2563EB", marginTop: "2px" }}>
                {km} KM
              </div>
            </div>
          </div>
        </div>

        {/* Modal Footer */}
        <div
          style={{
            padding: "14px 20px",
            backgroundColor: "#ffffff",
            borderTop: "1px solid #E2E8F0",
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
          }}
        >
          <button
            type="button"
            onClick={handleClose}
            style={{
              padding: "9px 18px",
              backgroundColor: "#F1F5F9",
              color: "#475569",
              border: "1px solid #CBD5E1",
              borderRadius: "8px",
              fontSize: "13px",
              fontWeight: "600",
              cursor: "pointer",
            }}
          >
            Dismiss
          </button>

          <button
            type="button"
            onClick={handleAssignClick}
            style={{
              padding: "9px 20px",
              backgroundColor: isAccepted ? "#2563EB" : "#16A34A",
              color: "#ffffff",
              border: "none",
              borderRadius: "8px",
              fontSize: "13px",
              fontWeight: "700",
              cursor: "pointer",
              boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1)",
              display: "flex",
              alignItems: "center",
              gap: "6px",
            }}
          >
            {isAccepted ? "View Booking Details" : "Assign Driver Now ➔"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default BookingAlertModal;
